export const achievementData = {
    bio : "Evaluated accomplishments on a resume is incredible, yet I simply don't work with hard numbers. I have no information to help the nature of my work. Assuming you have bunches of important experience, the heading articulation of your resume will be an outline.",
    achievements : [
        {
            id : 1,
            title : 'Cisco',
            details : 'Cisco certifications validate your expertise and showcase your ability to transform Cyber Security with Web technology.',
            date : 'Apr 15, 2020',
            field : 'Cyber Security',
            image : 'https://genesisbcs.com/wp-content/uploads/2016/12/cisco2.png'
        },
        {
            id : 2,
            title : 'Web Engineering',
            details : 'HTML,CSS,Javascript, ReactJS,NodeJS, ExpressJS and mobile responsive web development, as well as strong skills and ability in writing clean and efficient code.',
            date : 'Jul 1, 2021',
            field : 'Web',
            image : 'https://play-lh.googleusercontent.com/edmBVFMS9fhuZycs2I6jCO7vGxhH434upOADR2e3x5Wi_s6Et4vcFY0gYs0q_B0qFS8=s180-rw'
        },
        {
            id : 3,
            title : 'Skin Disease',
            details : 'Machine learning is the study of computer algorithms that can improve automatically through experience and by the use of data. It is seen as a part of artificial intelligence.',
            date : 'jun 1, 2019',
            field : 'ML',
            image : 'https://www.guyhowto.com/wp-content/uploads/2020/12/107_6-Eczema.jpg'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/